import { render, staticRenderFns } from "./freight.vue?vue&type=template&id=660a67a6&scoped=true"
import script from "./freight.vue?vue&type=script&lang=ts"
export * from "./freight.vue?vue&type=script&lang=ts"
import style0 from "./freight.vue?vue&type=style&index=0&id=660a67a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660a67a6",
  null
  
)

export default component.exports